module.exports = __webpack_public_path__ + "static/media/Upsell_Tab_Best_Deal@3x.0b020197.png";